module.exports = __webpack_public_path__ + "static/img/weather09.b71f681c.png";